import { useCallback, useRef } from 'react';

const TRUE = () => true;

export const useResizeObserver = <T extends Element>(
  onResize: (entry: ResizeObserverEntry) => void,
  onInit?: (el: T) => void,
  shouldObserve: (el: T) => boolean = TRUE
) => {
  const resizeObserverRef = useRef(
    new ResizeObserver((entries) => {
      const entry = entries[0];
      if (!entry) {
        return;
      }
      onResize(entry);
    })
  );

  const resizeObserver = resizeObserverRef.current;

  return useCallback(
    (el: T | null) => {
      resizeObserver.disconnect();
      if (el && shouldObserve(el)) {
        resizeObserver.observe(el);
        onInit?.(el);
      }
    },
    [onInit, shouldObserve, resizeObserver]
  );
};
